import {MoreAboutEnterprise} from './common/MoreAboutEnterprise';
import {Job} from './Job';

export class Enterprise {
  id?: number;
  partnerId?: number;
  documentType?: string;
  documentNumber?: string;
  name?: string;
  tradeName?: string;
  email?: string;
  excluded?: number;
  isPartner = false;
  maxWorkflows?: number;
  createdByPersonId?: number;
  createAt?: string;
  active?: boolean;
  deleted?: boolean;
  observation?: string;
  isCustomer = false;
  storageLimit?: number;
  jobs?: Job[];
  logoBase64Data?: string;
  logoFilename?: string;
  // tslint:disable-next-line:variable-name
  _more?: MoreAboutEnterprise;
  moreAboutEnterprise?: MoreAboutEnterprise;
}
